import {UserTracker} from "../index.js";

const eventDics = {
    "google-sign-up": "sign-up:google-sign-up:click",// 구글 가입
    "invite-kakaotalk": "sign-up:invite-kakaotalk:click", // 카카오톡 초대
    "invite-messenger": "sign-up:invite-messenger:click", // 메신저로 초대 (모바일)
    "invite-google-contacts": "sign-up:invite-google-contacts:click", // google 연락처 초대 진입
    "invite-google-workspace": "sign-up:invite-google-workspace:click", // google 워크스페이스 초대
    "invite-google-submit": "sign-up:invite-google-submit:click", // google 초대 전송
    "invite-email": "sign-up:invite-email:click", // 이메일 주소로 초대 진입
    "invite-email-submit": "sign-up:invite-email-submit:click", // 이메일 주소로 초대 전송
    "invite-text-app": "sign-up:invite-text-app:click", // 문자앱으로 초대하기
    "copy-invite-link": "sign-up:copy-invite-link:click", // 초대 링크 복사
}

export const SignUpTracker = () => {
    const Tracker = Object.create(UserTracker)
    Tracker.track = (eventName, value = null) => {
        const event = eventDics[eventName];
        if (!event) return;

        return Tracker.trackAction({event: event, value, data: {}});
    }

    return Tracker;
}
